import axios from 'axios'

import { CART as ENDPOINT } from '../common/endpoints'
import { success, error } from './toast-notifications'
import { t } from './i18n'

const miniCart = document.querySelector('.c-navbar__toolbar-item--cart')

const removeProductFromCart = async (e) => {
	e.preventDefault()
	//console.debug(e)

	try {
		// remove item from cart
		const res = await axios.post(ENDPOINT, {
			action: 'remove',
			productId: e.currentTarget.dataset['product'],
			data: {
				lang: window.motostorm.lang
			}		
		})
		updateMiniCart(res.data)
		success(t('remove-from-cart-success'))
	} catch (err) {
		error(t('remove-from-cart-error'))
	}
}

const setupCartBtnsEvents = (miniCart) => {
	miniCart.querySelectorAll('.j-cart-remove').forEach(el => {
		el.addEventListener('click', removeProductFromCart)
	})
}

const removeCartBtnsEvents = (miniCart) => {
	miniCart.querySelectorAll('.j-cart-remove').forEach(el => {
		el.removeEventListener('click', removeProductFromCart)
	})
}

const updateMiniCart = (data) => {
	// create new fragment and attach events
	//const cartFragment = document.createElement('template')
	//cartFragment.innerHTML = data.cart
	//setupCartBtnsEvents(cartFragment)
	// remove events from current cart fragment
	//removeCartBtnsEvents(miniCart)
	// clear old Cart
	//miniCart.innerHTML = ''
	// insert fragment into DOM
	//miniCart.appendChild(cartFragment.content)
	miniCart.innerHTML = data.cart
	setupCartBtnsEvents(miniCart)
}

// init
if(miniCart){
	setupCartBtnsEvents(miniCart)
}

export { updateMiniCart }
